import { setNetworkStatus } from '../app/state/slices/global-slice';
import { store } from '../app/state/store';
import { MessageType } from '../services/actor-messages';
import { WorkerClient } from './worker-client';
import { setWorker } from './worker-container';

// TODO: get rid of this class completely, everything should be in main.tsx or ApplicationBootstrap.tsx
export class App {
    private _worker: WorkerClient | null = null;

    constructor() {
        addEventListener('online', () => {
            store.dispatch(setNetworkStatus({ offline: false }));
            this._worker?.actor?.sendAsync({ type: MessageType.onlineChanged, data: true });
        });

        addEventListener('offline', () => {
            store.dispatch(setNetworkStatus({ offline: true }));
            this._worker?.actor.sendAsync({ type: MessageType.onlineChanged, data: false });
        });
    }

    async initWorker(): Promise<WorkerClient> {
        if (this._worker) {
            throw new Error('Worker already exists!');
        }

        this._worker = new WorkerClient(this);
        setWorker(this._worker);
        await this._worker.initPromise;
        return this.worker;
    }

    disposeWorker() {
        this._worker?.remove();
        this._worker = null;
        setWorker(this._worker);
    }

    /** @description Inside react components use useFlightWorker */
    get worker() {
        return this._worker!;
    }
}

const app = new App();

export default app;
